module.exports = __webpack_public_path__ + "img/momiji inubashiri_lw.e15d1564.png";